import { render, staticRenderFns } from "./FilterableListPage.vue?vue&type=template&id=54094f50&scoped=true&"
import script from "./FilterableListPage.vue?vue&type=script&lang=js&"
export * from "./FilterableListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54094f50",
  null
  
)

export default component.exports